import type { IconBaseProps } from "./IconBase";
import IconBase from "./IconBase";

export const EqualsIcon = (props: IconBaseProps) => {
  return (
    <IconBase {...props}>
      <path
        fill="currentColor"
        d="M20.1,14.3H4.2c-0.7,0-1.3,0.6-1.3,1.3v1.3c0,0.7,0.6,1.3,1.3,1.3h15.9c0.7,0,1.3-0.6,1.3-1.3v-1.3
		C21.4,14.9,20.8,14.3,20.1,14.3z M20.1,6.3H4.2c-0.7,0-1.3,0.6-1.3,1.3V9c0,0.7,0.6,1.3,1.3,1.3h15.9c0.7,0,1.3-0.6,1.3-1.3V7.6
		C21.4,6.9,20.8,6.3,20.1,6.3z"
      />
    </IconBase>
  );
};

export default EqualsIcon;
